import {handleActions} from "redux-actions";

import {
    setCredentialsTypesManagerDialog,
    mergeCredentialsTypesManagerDialog,
    clearCredentialsTypes,
    getCredentialsTypes,
    getCredentialsTypesSuccess,
    getCredentialsTypesError,
} from "./actions";

const initialState = {
    isLoading: false,
    count: 0,
    codes: [],
    credentialsTypes: {
        codes: [],
        types: {}
    },
    createDialog: {
        initialData: null,
        isOpen: false,
        isLoading: false
    }
};

export const credentialsTypesReducer = handleActions(
    {
        [clearCredentialsTypes]: () => ({...initialState}),

        [getCredentialsTypes]: (state) => ({
            ...state,
            credentialsTypes: [],
            selectedCredentialsTypes: [],
            count: 0,
            isLoading: true
        }),
        [getCredentialsTypesSuccess]: (state, {payload}) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getCredentialsTypesError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [setCredentialsTypesManagerDialog]: (state, {payload}) => ({
            ...state,
            createDialog: {
                ...initialState.createDialog,
                ...payload
            }
        }),
        [mergeCredentialsTypesManagerDialog]: (state, {payload}) => ({
            ...state,
            createDialog: {
                ...state.createDialog,
                ...payload
            }
        })
    },
    initialState
);
